/* eslint-disable import/prefer-default-export */
export function clearFiltersFromLocalStorage() {
  Object.keys(localStorage)
    .filter((x) => x.endsWith(" Filters"))
    .forEach((x) => localStorage.removeItem(x));
}
